import { FaWhatsapp } from "react-icons/fa";

export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/254797655727?text=Hello%20NEXINDI%20TECH,%20I%20am%20interested%20in%20your%20services."
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <div className="relative">
        {/* Pulse Animation */}
        <span className="absolute inline-flex h-full w-full rounded-full bg-green-500 opacity-75 animate-ping"></span>

        {/* Button */}
        <div className="relative flex items-center justify-center w-16 h-16 bg-green-500 rounded-full shadow-xl hover:bg-green-600 transition duration-300">
          <FaWhatsapp className="text-white text-4xl" />
        </div>

        {/* Tooltip */}
        <div className="absolute right-20 top-1/2 -translate-y-1/2 bg-gray-900 text-white text-sm px-3 py-2 rounded-lg opacity-0 group-hover:opacity-100 transition whitespace-nowrap">
          Chat with us on WhatsApp
        </div>
      </div>
    </a>
  );
}